import { Box, Group } from '@mantine/core';
import { RevisionRow } from 'components/tables/data/revision/types';
import { IconUser } from '@tabler/icons-react';
import P2Regular from 'components/typography/P2Regular';
import Toast from 'components/Toast';

/**
 * Column for the technician's name.
 */
export default function TechnicianNameColumn({ data: { technician } }: { data: RevisionRow }) {
  if (!technician) {
    return <Toast size="s" message="Nepridelený" type="fail" withCloseButton={false} />;
  }

  return (
    <Group spacing={8} noWrap align="center">
      <Box w={24} h={24}>
        <IconUser stroke={1.5} height={24} width={24} />
      </Box>
      <P2Regular color="gray.8">{technician.fullName}</P2Regular>
    </Group>
  );
}
